/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

const getChannelKey = (channel, roaming) => {
  return `${`00${channel}`.substr(-2)}_${roaming}`;
};

const abAbsoluteSlotOffset = (slotLocation, logicSlotOffset, xOff) => {
  const xint = 3;
  const sizeInWindow = slotLocation.length;  // 该slot类型在window 中的数量
  const logicOffsetInWindow = logicSlotOffset % sizeInWindow; // slot节点在window 中的偏移
  const logicWindowOffset = _.parseInt(logicSlotOffset / sizeInWindow); // window在逻辑序列中的偏移

  const groupOffset = _.parseInt(logicWindowOffset / (xint - 1)); // 节点所在goup 在group序列中的偏移
  let offsetInGroup = logicWindowOffset % (xint - 1); // 节点所在window 在group 中的偏移
  if (offsetInGroup >= xOff) {
    offsetInGroup += 1;  // 进行校正，如果X型window 在前则需要计算在内。
  }
  return (((groupOffset * xint) + offsetInGroup) * 10) + slotLocation[logicOffsetInWindow];
};

const absoluteSlotOffset = (frame, xOff, logicSlotOffset) => {
  const xOffData = xOff % 3;
  const xint = 3;
  const aSlotLocation = [0, 2, 4, 6, 7];
  const bSlotLocation = [1, 3, 5];
  if (Number(frame) === 0) {
    return ((xint * logicSlotOffset) + xOffData) * 10;
  } else if (Number(frame) === 1) {
    return abAbsoluteSlotOffset(aSlotLocation, logicSlotOffset, xOffData);
  }
  return abAbsoluteSlotOffset(bSlotLocation, logicSlotOffset, xOffData);
};

const handleBind = (node, bind, channelxOffData) => {
  const channelKey = getChannelKey(bind.channel, node.roaming);
  const offset = absoluteSlotOffset(bind.frame, channelxOffData[channelKey], bind.offset);
  const quality =
    _.parseInt((node.counters.alohaup * 100) /
      ((node.counters.alohaup + node.counters.tdmup) || 1));

  return { channelKey, offset, quality };
};

const isPass = (offset, channel, service, filter = {}) => {
  let offsetData = filter.offset || '';
  offsetData = _.split(offsetData, '-');
  if (offset < Number(offsetData[0]) || offset > Number(offsetData[1])) {
    return true;
  }
  // channel过滤为多选
  const channels = filter.channel || [];
  if (channels.length > 0 && !_.includes(channels, channel)) {
    return true;
  }
  // service过滤为多选
  const services = filter.service || [];
  if (services.length > 0 && !_.includes(services, service)) {
    return true;
  }
  return false;
};

export const handleNodeData = (nodes, channelxOffData, filter) => {
  let channels = [];
  let offsets = [];
  const data = [];
  const nodeInfoMap = {};
  const channelQuality = {};
  let allChannels = [];
  nodes.forEach((node) => {
    node.binds.forEach((bind) => {
      const { channelKey, offset, quality } = handleBind(node, bind, channelxOffData);

      allChannels.push(channelKey);

      if (isPass(offset, channelKey, bind.service, filter)) {
        return;
      }

      channels.push(channelKey);
      offsets.push(offset);
    });
  });

  channels = _.sortBy(_.uniq(channels));
  offsets = _.sortBy(_.uniq(offsets));
  allChannels = _.sortBy(_.uniq(allChannels));

  allChannels.forEach((channelKey) => {
    channelQuality[channelKey] = {
      key: channelKey, // key (在排序时用到key)
      num: 0,  // 总数
      avg: 0,  // 平均
      sum: 0,  // 总和
      worst: 0, // < 5
      bad: 0,  // >= 5
      middle: 0,  // >= 10
      better: 0, // >= 20
      good: 0,  // >= 40
    };
  });

  const rangeQuality = { bad: 5, middle: 10, better: 20, good: 40 };
  nodes.forEach((node) => {
    node.binds.forEach((bind) => {
      const { channelKey, offset, quality } = handleBind(node, bind, channelxOffData);

      // 获取总和，总数
      channelQuality[channelKey].sum += quality;
      channelQuality[channelKey].num += 1;
      // 获取范围的统计数据
      if (quality < 5) {
        channelQuality[channelKey].worst += 1;
      } else {
        _.map(_.keys(rangeQuality), (key) => {
          if (quality >= rangeQuality[key]) {
            channelQuality[channelKey][key] += 1;
          }
        });
      }

      if (isPass(offset, channelKey, bind.service, filter)) {
        return;
      }

      const x = _.indexOf(offsets, offset);
      const y = _.indexOf(channels, channelKey);

      const item = [x, y, quality];
      data.push(item);

      const nodeInfo = {
        base: {
          id: node.id,
          accuracy: node.accuracy,
          service: bind.service,
          frame: bind.frame,
          offset,
          bindOffset: bind.offset,
        },
        counters: node.counters,
        time: {
          lastatt: moment(node.lastatt).format('YYYY-MM-DD HH:mm:ss'),
          lastup: moment(node.lastup).format('YYYY-MM-DD HH:mm:ss'),
        },
      };

      nodeInfoMap[`${x}_${y}`] = nodeInfo;
    });
  });

  allChannels.forEach((channelKeys) => {
    channelQuality[channelKeys].avg =
      channelQuality[channelKeys].sum / (channelQuality[channelKeys].num || 1);
  });

  return {
    channels,
    offsets,
    data,
    nodeInfoMap,
    channelQuality,
  };
};




// WEBPACK FOOTER //
// ./src/containers/Network/coms/TDMStatis/util.js